import {
    SparkleAdOptions,
    SparkleProviderProps,
} from "@foundation/sparkle/lib/types";

import { AdConfig } from "~api/getAdConfig";
import type { Story } from "~types/types";

import { pathnameFromUrl } from "./urlUtils";

const DEFAULT_ADCODE = "bloomberg/industries/article";
export const DEFAULT_PAGE_TYPE = "lightsaber-article";

const DECOUPLE_AD_OPTIONS: SparkleAdOptions = {
    strategy: "always",
};
export const getDecoupledAdOptions = () => ({
    isDecoupled: true,
    adOptions: DECOUPLE_AD_OPTIONS,
});

const getTargetingForStory = (story: Story | null): Record<string, unknown> => {
    const page = story?.adTargeting?.page;

    return {
        ...story?.adTargeting,
        page: page ? `lightsaber-${page}` : DEFAULT_PAGE_TYPE,
        url: pathnameFromUrl(story?.url),
    };
};

export const getAdCodeFromStory = (story: Story | null) =>
    story?.adTargeting?.adCode || DEFAULT_ADCODE;

export const getSparkleProviderOptions = (
    story: Story | null
): Omit<SparkleProviderProps, "children"> => {
    const defaultAdCode = getAdCodeFromStory(story);

    return {
        defaultAdCode,
        sparkleInitOptions: {
            useCachedConsent: true,
            pageTargeting: getTargetingForStory(story),
            breakpoints: {
                mobile: 0,
                tablet: 768,
                small_desktop: 1088,
                large_desktop: 1300,
            },
            observerOptions: { rootMargin: "0px 0px 300px 0px" },
            disableIAS: true,
            enableBombora: true,
            disableTrigr: true,
            adContextData: { adPageType: "article", slug: story?.slug },
            isDecoupled: true,
            excludeTargetingTypes: ["content"],
        },
    } as Omit<SparkleProviderProps, "children">;
};

export const sparkleAdOptions = (
    story: Story | null,
    adConfig: AdConfig
): SparkleAdOptions => {
    if (!story) return {};
    return {
        disableAds: story?.disableAds,
        targeting: getTargetingForStory(story),
        adCode: getAdCodeFromStory(story),
        adDemand: adConfig.adDemand,
    };
};
